import { render, staticRenderFns } from "./_tabWorkflow.vue?vue&type=template&id=51e34d17&"
import script from "./_tabWorkflow.vue?vue&type=script&lang=js&"
export * from "./_tabWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports